import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollElementToTop = (element: Element | null | undefined): void => {
  if (element instanceof HTMLElement) {
    element.scroll({ top: 0, left: 0 });
  }
};

const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    scrollElementToTop(document.documentElement);
    scrollElementToTop(document.body);
    scrollElementToTop(document.querySelector('.app-main'));
  }, [pathname]);

  return null;
};

export default ScrollToTop;
